<script>
import moment from 'moment'
import {
  RexInput,
  RexDate
} from '@/components/views/rexFieldsV2'

export default {
  name: 'events-participation-form',
  components: {
    RexInput,
    RexDate
  },
  computed: {
    modal() {
      return this.$store.getters['events/getParticipationFormModal']
    },
    form() {
      return this.$store.getters['events/getParticipationForm']
    }
  },
  methods: {
    moment,
    send() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$store.commit('events/updateParticipationFormModal', {
            isLoading: true
          })

          this.$store.dispatch('events/createLead', this.form)
        } else {
          this.$buefy.snackbar.open({
            message: '<span>Ошибка валидации</span>Проверьте правильность заполнения всех полей.',
            type: 'is-danger',
            position: 'is-top-right',
            actionText: 'ОК',
            duration: 10000
          })
        }
      })
    }
  }
}
</script>
<template>
  <div class="card">
    <div class="events-participation-form">
      <h2 class="events-participation-form__header">
        {{ modal.header }}
      </h2>
      <h3 class="events-participation-form__subheader">
        Оставьте заявку на участие в мероприятии.
      </h3>
      <div class="events-participation-form__main">
        <div class="events-edit-form__field">
          <rex-input
            label="Имя"
            name="name"
            store-module="events"
            target="participationForm.name"
            :is-disabled="modal.isLoading"
            :validate="{
              required: true
            }"
          />
        </div>
        <div class="events-edit-form__field">
          <rex-input
            label="Фамилия"
            name="surname"
            store-module="events"
            target="participationForm.surname"
            :is-disabled="modal.isLoading"
            :validate="{
              required: true
            }"
          />
        </div>
        <div class="events-edit-form__field">
          <rex-input
            label="Должность"
            name="post"
            store-module="events"
            target="participationForm.post"
            :is-disabled="modal.isLoading"
            :validate="{
              required: true
            }"
          />
        </div>
        <div class="events-edit-form__field">
          <rex-input
            label="Полное название компании"
            name="agencyName"
            store-module="events"
            target="participationForm.agencyName"
            :is-disabled="modal.isLoading"
            :validate="{
              required: true
            }"
          />
        </div>
        <div class="events-edit-form__field">
          <rex-input
            label="Город"
            name="participantCity"
            store-module="events"
            target="participationForm.city"
            :is-disabled="modal.isLoading"
            :validate="{
              required: true
            }"
          />
        </div>
        <div class="events-edit-form__field">
          <rex-input
            label="ИНН"
            name="inn"
            store-module="events"
            target="participationForm.inn"
            :is-disabled="modal.isLoading"
            type="number"
            :validate="{
              required: true,
              min: 10,
              max: 12
            }"
          />
        </div>
        <div class="events-edit-form__field">
          <rex-input
            label="Телефон"
            name="phone"
            store-module="events"
            target="participationForm.phone"
            :is-disabled="modal.isLoading"
            type="tel"
            placeholder="+X XXX XXX XX XX"
            :validate="{
              required: true,
              phone: form.phone
            }"
          />
        </div>
        <div class="events-edit-form__field">
          <rex-input
            label="email"
            name="email"
            store-module="events"
            target="participationForm.email"
            :is-disabled="modal.isLoading"
            type="email"
            :validate="{
              required: true,
              email: true
            }"
          />
        </div>
      </div>
      <div
        v-if="modal.showPassportForm"
        class="events-participation-form__additional"
      >
        <h3
          class="
            events-participation-form__subheader
            events-participation-form__subheader--no-padding
          "
        >
          Можете оставить данные для бронирования или прислать их позже:
        </h3>
        <div class="events-edit-form__field">
          <rex-input
            label="Имя (как в паспорте)"
            name="foreignPassportName"
            store-module="events"
            :uppercase="true"
            target="participationForm.foreignPassport.name"
            :is-disabled="modal.isLoading"
          />
        </div>
        <div class="events-edit-form__field">
          <rex-input
            label="Фамилия (как в паспорте)"
            name="foreignPassportSurname"
            store-module="events"
            :uppercase="true"
            target="participationForm.foreignPassport.surname"
            :is-disabled="modal.isLoading"
          />
        </div>
        <div class="events-edit-form__field">
          <rex-date
            label="Дата рождения"
            name="foreignPassportBirthday"
            store-module="events"
            target="participationForm.foreignPassport.birthday"
            :is-disabled="modal.isLoading"
            :min-date="moment().subtract(100, 'years').toDate()"
            :max-date="moment().subtract(10, 'years').toDate()"
            :allow-null-date="true"
          />
        </div>
        <div class="events-edit-form__field">
          <rex-input
            label="Номер загранпаспорта"
            name="foreignPassportNumber"
            store-module="events"
            target="participationForm.number"
            type="number"
            :is-disabled="modal.isLoading"
          />
        </div>
        <div class="events-edit-form__field">
          <rex-date
            label="Срок действия загранпаспорта"
            name="foreignPassportExpirationDate"
            store-module="events"
            target="participationForm.foreignPassport.expirationDate"
            position="is-top-left"
            :is-disabled="modal.isLoading"
            :allow-null-date="true"
          />
        </div>
      </div>
      <div class="events-participation-form__action">
        <b-button
          class="rex-button2"
          type="is-primary"
          :disabled="modal.isLoading"
          :loading="modal.isLoading"
          expanded
          @click="send"
        >
          Отправить
        </b-button>
      </div>
    </div>
  </div>
</template>